import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";

export interface ReviewJobData {
    guid: string;
}

export class ReviewJob implements FormValidationModel<ReviewJobData> {
    public data: ReviewJobData;
    public rules: yup.Schema<ReviewJobData>;

    public constructor() {
        this.data = {
            guid: "",
        };
        this.rules = yup.object<ReviewJobData>().shape({
            guid: yup.string().required().label("GUID"),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/careerCenter/ReviewJob.ts